// extracted by mini-css-extract-plugin
export default {"l":"_2863def0be"};